export class BodyUtility {
    ToggleScroll() {
        if (!$('html').hasClass('ax-noscroll')) {
            this.DisableScroll();
            return;
        }
        this.EnableScroll();
    }

    EnableScroll() {
        // Not locked (e.g. called twice on close): do nothing, otherwise a stale 'top' moves the page
        if (!$('html').hasClass('ax-noscroll')) {
            return;
        }
        let scrollTop = parseInt($('html').css('top')) || 0;
        $('html').removeClass('ax-noscroll').css('top', '');
        window.scrollTo(0, -scrollTop);
    }

    DisableScroll() {
        // Already locked: keep the saved position instead of overwriting it with 0
        if ($('html').hasClass('ax-noscroll')) {
            return;
        }
        if ($(document).height() > $(window).height()) {
            let scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
            $('html').addClass('ax-noscroll').css('top', -scrollTop);
        }
    }

    enableOverlay() {
        let scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        $('html').addClass('ax-noscroll').css('top', -scrollTop);
    }

    disableOverlay() {
        let scrollTop = parseInt($('html').css('top'));
        $('html').removeClass('ax-noscroll');
        $('html,body').scrollTop(-scrollTop);
    }
}